import React from 'react'
import { colors } from '../../../../../Components/consts'
import { StarFilled } from '../../../../../Components/Icons'
import { ASRostersCon, TeamImageCon } from '../styles'
import { Coaches } from './Coaches/Coaches'
import { Desc, Head, Head2 } from '../../../../../Components/Typography/Text.styles'
import { Img } from '../../../../../Components/Image/Img'
import { ALL_STAR_IMAGES } from '../../../consts'
import { RosterAway } from './RosterAway'
import { RosterHome } from './RosterHome'

export const Rosters: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <ASRostersCon>
      <Desc
        justify="center"
        textColor={colors.gray.gray40}
        sideMargins={2}
        vertMargins={8}
      >{`The 2024 PLL All-Star Game will feature the inaugural exhibition between the Eastern Conference All-Stars vs Western Conference All-Stars. Witness the best players in the world, all on one field, in this historic matchup.`}</Desc>
      <TeamImageCon>
        <Img className="teamImg" src={ALL_STAR_IMAGES.teamOne} alt="Eastern all stars" />
        <Img className="teamImg" src={ALL_STAR_IMAGES.teamTwo} alt="Western all stars" />
      </TeamImageCon>
      <Head justify="center" textColor={colors.gray.gray20}>
        Rosters
      </Head>
      <div className="subHeader">
        <StarFilled fill={colors.yellow} width={15} />
        <p>: Career All-Star Selections</p>
      </div>

      <Head2 justify="center" textColor={colors.gray.gray20}>
        {'Coaches'}
      </Head2>
      <div className="section">
        <Coaches />
      </div>

      <Head2 justify="center" textColor={colors.gray.gray20}>
        {'Starters'}
      </Head2>
      <div className="section">
        <RosterAway rosterType="starter" side="left" />
        <RosterHome rosterType="starter" side="right" />
      </div>

      <Head2 justify="center" textColor={colors.gray.gray20}>
        {'Reserves'}
      </Head2>
      <div className="section">
        <RosterAway rosterType="active" side="left" />
        <RosterHome rosterType="active" side="right" />
      </div>
      <Head2 justify="center" textColor={colors.gray.gray20}>
        {'Injured'}
      </Head2>
      <div className="section">
        <RosterAway rosterType="injured" side="left" />
        <RosterHome rosterType="injured" side="right" />
      </div>
    </ASRostersCon>
  )
}
